import useAuth from "./useAuth";
import useAccount from "./useAccount";
import React, {useContext, useEffect} from "react";
import {LanguageContext} from "../Context/LanguageContext";
import axios from "axios";
import Constants from "../Configuration";
import useProgress from "./useProgress";
import {RequestType} from "../Services/ApiService";
import {AuthContext} from "../Context/RootContext";

export type IPriceInfo = {
    id: number,
    days: number | string | {value: number | string; bonus?: number},
    price: number
    usdPrice: number
    discount: number
    digUrl: string
    isCis: boolean
    paymentLinks: Record<string, IPaymentLink>
}

export const getPriceDays = (price: IPriceInfo): number => {
    const days = price.days;
    const value = typeof days === 'object' ? days.value : days;
    return Number(String(value).replace(/^Days/i, ''));
};

export const getPriceAmount = (price: IPriceInfo): number => price.isCis ? price.price : price.usdPrice;

export const formatPrice = (price: IPriceInfo | undefined, perDay = false): string => {
    if (!price) return '—';
    const days = getPriceDays(price);
    const amount = getPriceAmount(price);
    if (!Number.isFinite(amount) || (perDay && days <= 0)) return '—';
    const value = perDay ? amount / days : amount;
    const digits = perDay || !price.isCis || !Number.isInteger(value) ? 2 : 0;
    return price.isCis ? `${value.toFixed(digits)}₽` : `$ ${value.toFixed(2)}`;
};

export type IPaymentLink = {
    url: string;
    isGenerated?: boolean;
    currency?: string;
}

export const getConfiguredPaymentLink = (price: IPriceInfo | undefined, provider: string): IPaymentLink | undefined => {
    const link = price?.paymentLinks?.[provider];
    if (!link?.url) return undefined;
    if (link.isGenerated) {
        return /^\/Payment\/[^?#\\]+$/i.test(link.url) ? link : undefined;
    }
    try {
        return new URL(link.url).protocol === 'https:' ? link : undefined;
    } catch {
        return undefined;
    }
};

export type IPayment = {
    price: string;
    daysEnum: number;
    createdTime: string;
}

export type IToken = {
    createReason: 1
    lifeTime: 1
}

export enum AddSubReasonEnum
{
    Unset = 0,
    VkPay = 3,
    Digseller = 4,
    DigsellerReseller = 5,
    ResellerChina = 6,
    FreeKassa = 7,
    Paymaster = 8,
    JustToken = 9,
    JustPayment = 10,
    FreeSubscription = 16
}

export type ISubReasonObject = {
    payment?: IPayment;
    token?: IToken;
    subReason: AddSubReasonEnum;
    createdTime: string;
    days?: number;
}

export const usePayment = () => {
    // const {user} = useAuth();
    // const {userInfo, loadUserInfoAndSave} = useAccount();
    // const userId = user?.profile?.sub;
    const state = React.useContext(AuthContext)
    const {lang} = useContext(LanguageContext);
    const {error, isLoading, BeginLoading} = useProgress();
    useEffect(() => {
        // loadUserInfoAndSave();
    }, [])


    const getPaymentLink = async (path: string) => {
        return await BeginLoading(async () => {
            const data = await state.apiService.callApi(Constants.apiEndpoint + path.replace(/^\/+/, ''));
            return data.data;
        })
    }
    const getPrimePaymentsPaymentLink = async (priceId: number, currency: string) => {
        return await BeginLoading(async () => {
            const data = await state.apiService.callApi(Constants.apiEndpoint +  `payment/PrimePayments/GetPaymentModel/${priceId}/${currency}`);
            return data.data;
        })
    }
    const getPaymaxPaymentLink = async (priceId: number, currency: string) => {
        return await BeginLoading(async () => {
            const data = await state.apiService.callApi(Constants.apiEndpoint + `Payment/Paymax/GetPaymentForm/${priceId}/${currency}`);
            return data.data;
        })
    }
    const getPaymentLinkForPaymaster = async (priceId: number, currency: string) => {
        return await BeginLoading(async () => {
            const data = await state.apiService.callApi(Constants.apiEndpoint +  `payment/Paymaster/GetPaymentModel/${priceId}/${currency}`);
            return data.data;
        })
    }
    const getPrices = async () => {
        return await BeginLoading(async () => {
            const data = await state.apiService.callApi(Constants.apiEndpoint +  `info/prices`);
            return data.data as IPriceInfo[];
        })
    }
    const getPaymentByUser = async (userId: string): Promise<ISubReasonObject[]> => {
        return await BeginLoading(async () => {
            const data = await state.apiService.callApi(Constants.apiEndpoint +  `payment/GetAllPayments/db/${userId}`);
            return data.data as ISubReasonObject[];
        })
    }

    return {
        getPaymentLink,
        getPaymentByUser,
        getPaymentLinkForPaymaster,
        getPaymaxPaymentLink,
        getPrimePaymentsPaymentLink,
        isLoading,
        getPrices
    }
}
